/**
 * App — router + provider wiring. Public /login; everything else is behind
 * <RequireAuth> inside the authenticated <Layout> shell.
 */
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './auth/AuthContext';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Upload } from './pages/Upload';
import { LeadDetail } from './pages/LeadDetail';
import { OutreachEditor } from './pages/OutreachEditor';
import { Benchmarks } from './pages/Benchmarks';
import { BenchmarkDetail } from './pages/BenchmarkDetail';
import { Suppliers } from './pages/Suppliers';
import { Sources } from './pages/Sources';
import { SelectionAudits } from './pages/SelectionAudits';
import { SelectionAuditDetail } from './pages/SelectionAuditDetail';
import { ContentAudits } from './pages/ContentAudits';
import { ContentAuditDetail } from './pages/ContentAuditDetail';
import { Admin } from './pages/Admin';
import { Assistant } from './pages/Assistant';
import { AdminAssistant } from './pages/AdminAssistant';

export function App(): JSX.Element {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/leads/:id" element={<LeadDetail />} />
            <Route path="/leads/:id/outreach" element={<OutreachEditor />} />
            <Route path="/benchmarks" element={<Benchmarks />} />
            <Route path="/benchmarks/:id" element={<BenchmarkDetail />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/sources" element={<Sources />} />
            <Route path="/selection-audits" element={<SelectionAudits />} />
            <Route
              path="/selection-audits/:id"
              element={<SelectionAuditDetail />}
            />
            <Route path="/content-audits" element={<ContentAudits />} />
            <Route
              path="/content-audits/:id"
              element={<ContentAuditDetail />}
            />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/assistant" element={<AdminAssistant />} />
            <Route path="/assistant" element={<Assistant />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
